<div class="flex-column">
    <div class="flex-column bg-primary-lighter p-1">
        <span class="text-primary-darker-h3 ml-1 mbs-1">{{ 'modules.attentions.dialog-evolution.template-title' | exp:'':'Evolucionar atención' }} - {{this.data.attention?.patient.surname + '
            ' + this.data.attention.patient.name}}</span>
        <span class="text-secondary ml-1">{{
            this.data.attention?.practice?.name +
            ' - ' +
            (this.data.attention.fromScheduled | date: 'dd/MM/yyyy hh:mm') + 'hs' +
            ((!!this.data.attention?.toScheduled) ?' a ' : '') +
            (!!this.data.attention?.toScheduled ? (this.data.attention?.toScheduled | date: 'dd/MM/yyyy hh:mm')+ 'hs' :
            '' )
            }}</span>
    </div>
    <div class="flex-column p-24">
        <span class="text-primary-darker-h4 mbs-3">
            {{ 'modules.attentions.dialog-evolution.evolution-data' | exp:'':'Datos de la evolución' }}
        </span>
        <div class="flex-row flex-100">
            <div class="flex-column flex-25">
                <span class="subtitle-2">{{ 'modules.attentions.dialog-evolution.evolution-type' | exp:'':'Tipo de evolución' }} *</span>
                <app-select-input [name]="this.EVOLUTION_TYPE" [form]="this.evolutionForm"
                    [placeholder]="('modules.attentions.dialog-evolution.placeholders.select-evolution-category' | exp:'':'Seleccionar...')" [elements]="this.evolutionCategories"
                    [calculateId]="this.calculateCategoryOfEvolutionId"
                    [calculateName]="this.calculateCategoryOfEvolutionName" (selected)="onSelectCategory($event)">
                </app-select-input>
            </div>
            <div class="flex-column ml-5 flex">
                <span class="subtitle-2">{{ 'modules.attentions.dialog-evolution.evolution-visibility' | exp:'':'Visibilidad de la evolución' }}</span>
                <div *ngIf="this.PRACTICE_QUALITY_CONTROL_ID.toString() != this.data.attention?.practice?.id.toString()"
                    class="flex-row wrap gap-5percent flex-100">
                    <mat-checkbox id="visibleFinancier" (change)="financierVisibility = !financierVisibility"
                        [checked]="this.financierVisibility">
                        {{ this.data.attention?.financier?.name }}
                    </mat-checkbox>
                    <mat-checkbox id="visibleProvider" (change)="providersVisibility = !providersVisibility"
                        [checked]="this.providersVisibility">
                        {{ 'modules.attentions.dialog-evolution.providers' | exp:'':'Prestadores' }}
                    </mat-checkbox>
                </div>
            </div>
        </div>
        <div>
            <form *ngIf="this.evolutionForm" [formGroup]="evolutionForm">
                <div class="flex-row space-between-center">
                    <!-- Textarea -->
                    <div class="flex-45">
                        <app-text-area-input [clearable]="false" [form]="this.evolutionForm"
                            [name]="this.EVOLUTION_TEXT" [placeholder]="('modules.attentions.dialog-evolution.placeholders.evolution-text' | exp:'':'Ingrese el texto de la evolución')"
                            (change)="onChangeDescription($event)">
                        </app-text-area-input>
                    </div>
                    <!-- Filepond -->
                    <div class="flex-45">
                        <file-pond #myPond [options]="pondOptions" (oninit)="pondHandleInit()"
                            (onaddfile)="pondHandleAddFile($event)" (onremovefile)="pondHandleRemoveFile($event)"
                            (onaddfilestart)="pondHandleProcessFile($event)">
                        </file-pond>
                    </div>
                </div>
                <app-checkbox-input class="flex-row addTask" [form]="this.evolutionForm" [label]="('modules.attentions.dialog-evolution.template-evolution-form.labels.add-task' | exp:'':'Crear una tarea')"
                    [labelPosition]="'before'" [name]="this.ADD_TASK">
                </app-checkbox-input>
                @if(isAddingTask){
                    <span class="subtitle-3 text-primary-darker-h3">
                        {{ 'modules.attentions.dialog-evolution.template-evolution-form.operator' | exp:'':'Operador' }} *
                    </span>
                    <app-select-searching-input [name]="this.OPERATOR" [nameSearching]="this.OPERATOR_SEARCHING"
                        [form]="this.evolutionForm"
                        [placeholder]="('modules.attentions.dialog-evolution.placeholders.select-operator' | exp:'':'Seleccionar')" [elements]="this.operators"
                        [defaultValue]=""
                        [calculateId]="this.calculateIdOperator" [calculateName]="this.calculateNameOperator"
                        [placeholderNoValue]="('modules.attentions.dialog-evolution.template-evolution-form.placeholders.no-value' | exp:'':'Sin resultados')"
                        [placeholderSearching]="('modules.attentions.dialog-evolution.placeholders.searching-operator' | exp:'':'Buscar...')">
                    </app-select-searching-input>
                }
            </form>
        </div>
        <!-- FIN Paso #1 -->
        <!-- INICIO Paso #2 -> Indique en qué estado queda la atención (Sólo evoluciones no normales) -->
        <div class="flex-column">
            <span class="text-primary-darker-h4 mbs-3">
                {{ 'modules.attentions.dialog-evolution.attention-last-state' | exp:'':'Estado final de la atención' }}
            </span>
            <div class="flex-100">
                <form *ngIf="attentionStateForm && !!this.data.attention" [formGroup]="attentionStateForm"
                    class="flex-row  flex-100">
                    <div class="flex-column flex-20">
                        <span class="subtitle-2">{{ 'modules.attentions.dialog-evolution.template-attention-state-form.date-in-out-real' | exp:'':'Fecha de realización' }}</span>
                        <app-date-picker [name]="this.DATE_IN_REAL" [form]="this.attentionStateForm" class="mb-0"
                            (onDateChange)="setHourDifference()">
                        </app-date-picker>
                        <app-date-picker [name]="this.DATE_OUT_REAL" [form]="this.attentionStateForm"
                            *ngIf="this.data.attention?.practice?.restriction?.requiredToDate"
                            (onDateChange)="setHourDifference()">
                        </app-date-picker>
                    </div>
                    <div class="flex-column flex-30 ml-2">
                        <span class="subtitle-2">{{ 'modules.attentions.dialog-evolution.template-attention-state-form.time-in-out-real' | exp:'':'Hora de realización' }}</span>
                        <app-text-input [form]="this.attentionStateForm" [selectAllOnClick]="true"
                            (changes)="validateTimeValid()" [name]="this.REAL_TIME_FROM"
                            (keydown.enter)="$event.preventDefault()">
                        </app-text-input>
                        <!-- Hour OUT -->
                        <app-text-input  *ngIf="this.data.attention?.practice?.restriction?.requiredToDate" [form]="this.attentionStateForm" [selectAllOnClick]="true"
                            (changes)="changeHourFinish()" [name]="this.REAL_TIME_TO"
                            (keydown.enter)="$event.preventDefault()">
                        </app-text-input>
                    </div>
                    <div class="flex-column flex-20 ml-2" *ngIf="this.durationNeeded">
                        <span class="subtitle-2">{{ 'modules.attentions.dialog-evolution.template-attention-state-form.quantity' | exp:'':'Duración' }} *</span>
                        <app-number-input [form]="this.attentionStateForm" [name]="this.QUANTITY"
                            (change)="this.durationChanged()" [money]='false' [placeholder]="'Horas'" [minValue]="0">
                        </app-number-input>
                        <i style="color: var(--color-warning-accent);" class="subtitle-3" *ngIf="this.showAlertMsg">{{ 'modules.attentions.dialog-evolution.quantity-modification-alert.text' | exp:'':'La duración de la atención ha sido modificada' }}</i>
                    </div>
                    <div class="flex-column ml-2 flex-40" style="width: 40%;">
                        <span class="subtitle-2">{{ 'modules.attentions.dialog-evolution.template-attention-state-form.attention-state' | exp:'':'Estado de la atención' }}</span>
                        <app-select-input [name]="this.STATE_ATTENTION" [form]="this.attentionStateForm"
                            [placeholder]="('modules.attentions.dialog-evolution.placeholders.select-operator' | exp:'':'Seleccionar')"
                            [hint]="('modules.attentions.dialog-evolution.hints.attention-state' | exp:'':'Estado actual de la atención') + ': ' +this.data.attention?.state.name"
                            [elements]="this.attentionStates" [calculateId]="this.calculateId"
                            [calculateName]="this.calculateName"
                            [disabled]="this.data.attention?.state.id == ATTENTION_STATES.INFORMADA">
                        </app-select-input>
                    </div>
                </form>
            </div>
            <!-- FIN Paso #2-->
        </div>
        <div class="flex-row align-space-around-stretch mts-2">
            <button mat-stroked-button [color]="'primary'" [disabled]="this.loadingConfirm" (click)="onCancelClick()">
                {{ ('common.cancel' | exp:'':'Cancelar')  }}
            </button>
            <button mat-flat-button [color]="'primary'"
                [disabled]="!this.evolutionForm.valid || !this.attentionStateForm.valid || this.loadingConfirm || this.loadingAddFile"
                (click)="onConfirmClick()">
                <span *ngIf="!this.loadingConfirm; else loadingConfirmIcon">
                    {{ ('common.confirm' | exp:'':'Confirmar')  }}
                </span>
                <ng-template #loadingConfirmIcon>
                    <mat-icon>
                        <mat-spinner color="accent" diameter="20">
                        </mat-spinner>
                    </mat-icon>
                </ng-template>
            </button>
        </div>
    </div>
</div>
